import * as React from 'react';
import { SVGProps } from 'react';

const IconTrashSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 1a1 1 0 0 0-1 1v1H2v1h1v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h1V3h-4V2a1 1 0 0 0-1-1H7zM6 6h1v6H6V6zm4 0H9v6h1V6z"
    />
  </svg>
);
export default IconTrashSizeS;
